var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-dialog',{attrs:{"name":_vm.name,"title":_vm.title}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":_vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }